import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HomeIcon from '@material-ui/icons/Home';
import PersonIcon from '@material-ui/icons/Person';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ListAltIcon from '@material-ui/icons/ListAlt';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Assessment } from '@material-ui/icons';
import logo from '../../assets/images/logo.png';
import { toggleDrawer } from '../../redux/actions/scaffolding';

const useStyles = makeStyles((theme) => ({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const LeftDrawer = ({ drawerStatus, toggleDrawerAction, logout }) => {
  const location = useLocation();
  const classes = useStyles();
  const [open, setOpen] = React.useState('');
  const user = JSON.parse(localStorage.getItem('user'));
  const currentLocation = location.pathname;
  const handleClick = (val) => {
    setOpen(val && val === open ? '' : val);
  };
  const isSuperAdmin = user?.id ? [345, 347, 351].includes(user.id) : false;
  const list = () => (
    <div
      className={clsx(classes.list, { [classes.fullList]: false })}
      role="presentation"
      // onClick={() => toggleDrawerAction(false)}
      //  onKeyDown={() => toggleDrawerAction(false)}
    >
      {user ? (
        <>
          <List>
            <ListItem>
              <ListItemIcon>
                <ArrowBackIos />
              </ListItemIcon>
              <img src={logo} alt="Logo" height="53" />
            </ListItem>
          </List>
          <List>
            <Link to="/dashboard" onClick={() => toggleDrawerAction(false)}>
              <ListItem
                button
                selected={
                  currentLocation === '/' || currentLocation === '/dashboard'
                }
              >
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItem>
            </Link>
            {user.userType === 'admin' && (
              <>
                {isSuperAdmin && (
                  <Link to="/sync-data" onClick={() => toggleDrawerAction(false)}>
                    <ListItem button selected={currentLocation === '/sync-data'}>
                      <ListItemIcon>
                        <BusinessCenterIcon />
                      </ListItemIcon>
                      <ListItemText primary="Sync ROMS Data" />
                    </ListItem>
                  </Link>
                )}
                <ListItem
                  button
                  onClick={() => handleClick('report')}
                  selected={currentLocation === '/report'}
                >
                  <ListItemIcon>
                    <Assessment />
                  </ListItemIcon>
                  <ListItemText primary="Report" />
                  {open === 'report' ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open === 'report'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <Link
                      to="/report"
                      onClick={() => toggleDrawerAction(false)}
                    >
                      <ListItem
                        button
                        className={classes.nested}
                        selected={currentLocation === '/report'}
                      >
                        <ListItemIcon>
                          <Assessment />
                        </ListItemIcon>
                        <ListItemText primary="FOC Report" />
                      </ListItem>
                    </Link>
                    {/* <Link to="/ata-report" onClick={() => toggleDrawerAction(false)}>
                      <ListItem
                        button className={classes.nested}
                        selected={currentLocation === '/ata-report'}
                      >
                        <ListItemIcon>
                          <Assessment />
                        </ListItemIcon>
                        <ListItemText primary="ATA Report" />
                      </ListItem>
                    </Link> */}
                  </List>
                </Collapse>
                {isSuperAdmin
                  ? (
                    <>
                      <Link
                        to="/assign-products"
                        onClick={() => toggleDrawerAction(false)}
                      >
                        <ListItem
                          button
                          selected={currentLocation === '/assign-products'}
                        >
                          <ListItemIcon>
                            <BusinessCenterIcon />
                          </ListItemIcon>
                          <ListItemText primary="Assign Products" />
                        </ListItem>
                      </Link>
                      <Link
                        to="/dash-users"
                        onClick={() => toggleDrawerAction(false)}
                      >
                        <ListItem button selected={currentLocation === '/dash-users'}>
                          <ListItemIcon>
                            <PersonIcon />
                          </ListItemIcon>
                          <ListItemText primary="Product Managers" />
                        </ListItem>
                      </Link>
                    </>
                  )
                  : null}
              </>
            )}

            {(user.userType === 'admin' || user.userType === 'manager') && (
              <>
                <ListItem
                  button
                  onClick={() => handleClick('sites')}
                  selected={['/all-sites', 'sites-reported'].includes(
                    currentLocation,
                  )}
                >
                  <ListItemIcon>
                    <AssignmentIcon />
                  </ListItemIcon>
                  <ListItemText primary="Sites" />
                  {open === 'sites' ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open === 'sites'} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <Link
                      to="/all-sites"
                      onClick={() => toggleDrawerAction(false)}
                    >
                      <ListItem
                        button
                        className={classes.nested}
                        selected={currentLocation === '/all-sites'}
                      >
                        <ListItemIcon>
                          <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="All Sites" />
                      </ListItem>
                    </Link>
                    <Link
                      to="/sites-reported"
                      onClick={() => toggleDrawerAction(false)}
                    >
                      <ListItem
                        button
                        className={classes.nested}
                        selected={currentLocation === '/sites-reported'}
                      >
                        <ListItemIcon>
                          <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Reported Sites" />
                      </ListItem>
                    </Link>
                    <Link
                      to="/proposed-photos"
                      onClick={() => toggleDrawerAction(false)}
                    >
                      <ListItem
                        button
                        className={classes.nested}
                        selected={currentLocation === '/proposed-photos'}
                      >
                        <ListItemIcon>
                          <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Proposed Photos" />
                      </ListItem>
                    </Link>
                    <Link
                      to="/sites-comparison"
                      onClick={() => toggleDrawerAction(false)}
                    >
                      <ListItem
                        button
                        className={classes.nested}
                        selected={currentLocation === '/sites-comparison'}
                      >
                        <ListItemIcon>
                          <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Sites Comparison" />
                      </ListItem>
                    </Link>
                    <Link
                      to="/map-deleted-sites"
                      onClick={() => toggleDrawerAction(false)}
                    >
                      <ListItem
                        button
                        className={classes.nested}
                        selected={currentLocation === '/map-deleted-sites'}
                      >
                        <ListItemIcon>
                          <Assessment />
                        </ListItemIcon>
                        <ListItemText primary="Deleted Sites" />
                      </ListItem>
                    </Link>
                  </List>
                </Collapse>
                <Link
                  to="/assign-flex-date"
                  onClick={() => toggleDrawerAction(false)}
                >
                  <ListItem
                    button
                    selected={currentLocation === '/assign-flex-date'}
                  >
                    <ListItemIcon>
                      <Assessment />
                    </ListItemIcon>
                    <ListItemText primary="Manage Flex Date" />
                  </ListItem>
                </Link>
                <Link
                  to="/change-end-date"
                  onClick={() => toggleDrawerAction(false)}
                >
                  <ListItem
                    button
                    selected={currentLocation === '/change-end-date'}
                  >
                    <ListItemIcon>
                      <Assessment />
                    </ListItemIcon>
                    <ListItemText primary="Change End Date" />
                  </ListItem>
                </Link>
              </>
            )}
            {user.userType === 'clientUser' && (
              <Link to="/all-sites" onClick={() => toggleDrawerAction(false)}>
                <ListItem button selected={currentLocation === '/all-sites'}>
                  <ListItemIcon>
                    <AssignmentIcon />
                  </ListItemIcon>
                  <ListItemText primary="All Sites" />
                </ListItem>
              </Link>
            )}
            {(user.userType === 'buyer' || user.userType === 'supplier') && (
              <Link
                to="/sites-reported"
                onClick={() => toggleDrawerAction(false)}
              >
                <ListItem
                  button
                  selected={currentLocation === '/sites-reported'}
                >
                  <ListItemIcon>
                    <AssignmentIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reported Sites" />
                </ListItem>
              </Link>
            )}
            {user.userType === 'supplier' && (
              <>
                <Link
                  to="/assign-flex-date"
                  onClick={() => toggleDrawerAction(false)}
                >
                  <ListItem
                    button
                    selected={currentLocation === '/assign-flex-date'}
                  >
                    <ListItemIcon>
                      <AssignmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="All Sites" />
                  </ListItem>
                </Link>
              </>
            )}
            {user.userType === 'admin' && (
              <>
                <Link to="/suppliers" onClick={() => toggleDrawerAction(false)}>
                  <ListItem button selected={currentLocation === '/suppliers'}>
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary="Suppliers" />
                  </ListItem>
                </Link>
                <Link to="/buyers" onClick={() => toggleDrawerAction(false)}>
                  <ListItem button selected={currentLocation === '/buyers'}>
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary="Buyers" />
                  </ListItem>
                </Link>
              </>
            )}

            {(user.userType === 'client' || user.userType === 'auditor') && (
              <Link
                to="/reported-sites"
                onClick={() => toggleDrawerAction(false)}
              >
                <ListItem
                  button
                  selected={currentLocation === '/reported-sites'}
                >
                  <ListItemIcon>
                    <AssignmentTurnedInIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reported Sites" />
                </ListItem>
              </Link>
            )}
            {user.userType === 'rauditor' && (
              <Link
                to="/site-rapport-auditor"
                onClick={() => toggleDrawerAction(false)}
              >
                <ListItem
                  button
                  selected={currentLocation === '/site-rapport-auditor'}
                >
                  <ListItemIcon>
                    <AssignmentTurnedInIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reported Sites" />
                </ListItem>
              </Link>
            )}
            {(user.userType === 'client' || user.userType === 'auditor' || (user.userType === 'rauditor' && user.id !== 372)) && (
              <Link to="/atr-report" onClick={() => toggleDrawerAction(false)}>
                <ListItem button selected={currentLocation === '/atr-report'}>
                  <ListItemIcon>
                    <Assessment />
                  </ListItemIcon>
                  <ListItemText primary={user.userType === 'rauditor' ? 'FOC Report' : 'ATR Report'} />
                </ListItem>
              </Link>
            )}
            {user.userType !== 'buyer'
              && user.userType !== 'client'
              && user.userType !== 'auditor'
              && user.userType !== 'rauditor' && (
                <Link to="/monitors" onClick={() => toggleDrawerAction(false)}>
                  <ListItem button selected={currentLocation === '/monitors'}>
                    <ListItemIcon>
                      <SupervisorAccountIcon />
                    </ListItemIcon>
                    <ListItemText primary="Monitors" />
                  </ListItem>
                </Link>
            )}
            {isSuperAdmin && user.userType !== 'supplier'
              && user.userType !== 'client'
              && user.userType !== 'auditor'
              && user.userType !== 'rauditor' && (
                <Link to="/estimates" onClick={() => toggleDrawerAction(false)}>
                  <ListItem button selected={currentLocation === '/estimates'}>
                    <ListItemIcon>
                      <ListAltIcon />
                    </ListItemIcon>
                    <ListItemText primary="Estimates" />
                  </ListItem>
                </Link>
            )}
          </List>
        </>
      ) : null}
      <Divider />
      <List>
        <ListItem button onClick={logout}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div>
      <>
        <Drawer
          anchor="left"
          open={drawerStatus}
          onClose={() => toggleDrawerAction(false)}
        >
          {list()}
        </Drawer>
      </>
    </div>
  );
};

const mapState = (state) => ({
  drawerStatus: state.scaffoldingReducer.drawerStatus,
});

const mapActions = {
  toggleDrawerAction: toggleDrawer,
};
export default connect(mapState, mapActions)(LeftDrawer);
